import { ActionTypes } from '../actions/types';
import { UserSessionModel } from '../../models/UserSessionModel';
import { Auth } from '../../api';
import jwtDecode from 'jwt-decode';

const initialState: UserSessionModel = {
  isHauptmandant: false,
  isAdmin: false,
  isMain: false,
  isMetro: false,
  version: 0, // 0 = Standardversion
  isEditVorlage: false,
  isAuftragEdit: false,
  currentMandantId: '',
  languageId: 0,
  rowsInGrid: 50,
};

export default function (
  state = initialState,
  action: { type: ActionTypes; payload?: any }
) {
  const { type, payload } = action;
  const auth: Auth = { ...payload };

  switch (type) {
    case ActionTypes.SET_AUTHENTICATION: {
      try {
        let token = '';
        if (auth.accessToken !== undefined) token = auth.accessToken;
        const decodedToken: any = jwtDecode(token);
        return {
          ...state,
          isHauptmandant: JSON.parse(decodedToken.hauptmandant),
          isAdmin: JSON.parse(decodedToken.admin),
          isMain: JSON.parse(decodedToken.main),
          version: JSON.parse(decodedToken.version),
          isMetro: JSON.parse(decodedToken.metro),
          isEditVorlage: JSON.parse(decodedToken['edit']),
          isAuftragEdit: JSON.parse(decodedToken['edit']), //#81844 wird im Client auch so bedingt
          currentMandantId: JSON.parse(decodedToken['mandant-id']),
          languageId: JSON.parse(decodedToken['language-id']),
          rowsInGrid: JSON.parse(decodedToken.rowsInGrid),
        };
      } catch (err) {
        return state;
      }
    }
    case ActionTypes.SET_CURRENT_MANDANT_ID: {
      return {
        ...state,
        currentMandantId: payload,
      };
    }
    case ActionTypes.SET_ROWSINGRID: {
      return {
        ...state,
        rowsInGrid: payload,
      };
    }

    default:
      return state;
  }
}
